import { FormControl, FormGroupDirective, NgForm } from "@angular/forms";
import { ErrorStateMatcher } from "@angular/material";

export class ConfirmPasswordErrorStateMatcher implements ErrorStateMatcher {

    constructor(private key: string = "ConfirmPassword") {}

    isErrorState(control: FormControl, form: FormGroupDirective | NgForm): boolean {
        return (control.touched || control.dirty) && (control.invalid || (form.invalid && form.hasError(this.key)));
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/password/confirm-password-error-state-matcher.ts